module.exports = __webpack_public_path__ + "img/13.3c07458e.jpg";